import Config from 'Config';
import aws4 from 'aws4';

/**
 * `POST /projects/:projectId/publish-bulletin/:bulletinId` — release a draft,
 * or a bulletin the assistant wrote, to everyone who can read the board.
 * Returns the bulletin as the API now holds it.
 */
export default async function setPublishBulletin(
  projectId,
  bulletinId,
  params
) {
  const apiPath = `projects/${projectId}/publish-bulletin/${bulletinId}`;

  const request = {
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({}),
  };
  const signer = new aws4.RequestSigner(request, {
    accessKeyId: params.accessKeyId,
    secretAccessKey: params.secretAccessKey,
    sessionToken: params.sessionToken,
  });
  const signedRequest = signer.sign();
  signedRequest.headers.Accept = '*/*';

  const response = await fetch(
    `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    signedRequest
  ).then((res) => res.json());
  return response;
}
